/* eslint-disable react-hooks/exhaustive-deps, array-bracket-newline */
import React, { useState } from 'react';
import { LS_TICKERS_SEARCH_KEY } from './Table';

interface ITableWidths {
  pairs: number;
  price: number;
  liquidity: number;
  volume: number;
  contract: number;
  apy: number;
  kind: number;
  chain: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  pairs: 156,
  price: 163,
  liquidity: 116,
  volume: 163,
  contract: 106,
  apy: 80,
  kind: 156,
  chain: 116,
};

interface IUseTableDataProps {
  tickers: any;
}

const useTableData = ({ tickers }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_TICKERS_SEARCH_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => tickers, [tickers]);
  const columns = React.useMemo(
    () => [
      {
        id: 'pairs',
        Header: 'Pairs',
        accessor: 'pairs',
        disableSortBy: true,
        width: tableColumnsWidth['pairs'] || tableWidthsDefaultState['pairs'],
      },
      {
        id: 'price_a_usd',
        Header: 'Price',
        accessor: 'price_a_usd',
        width: tableColumnsWidth['price'] || tableWidthsDefaultState['price'],
      },
      {
        id: 'liquidity',
        Header: 'Liquidity',
        accessor: 'liquidity',
        width:
          tableColumnsWidth['liquidity'] ||
          tableWidthsDefaultState['liquidity'],
      },
      {
        id: 'volume',
        Header: 'Volume',
        accessor: 'volume',
        width: tableColumnsWidth['volume'] || tableWidthsDefaultState['volume'],
      },
      {
        id: 'contract',
        Header: 'Contract',
        accessor: 'contract',
        disableSortBy: true,
        width:
          tableColumnsWidth['contract'] || tableWidthsDefaultState['contract'],
      },
      {
        id: 'annual_percentage_yield',
        Header: 'APY',
        accessor: 'annual_percentage_yield',
        width: tableColumnsWidth['apy'] || tableWidthsDefaultState['apy'],
      },
      {
        id: 'chain',
        Header: 'Chain',
        accessor: 'chain',
        disableSortBy: true,
        width: tableColumnsWidth['chain'] || tableWidthsDefaultState['chain'],
      },
      {
        id: 'kind',
        Header: '',
        accessor: 'exchange',
        disableSortBy: true,
        width: tableColumnsWidth['kind'] || tableWidthsDefaultState['kind'],
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
